import { atom } from 'jotai';
import { Nullable } from '@/types/generic';

export const selectedGameIdForVideosAtom = atom<Nullable<number>>(null);
